// extracted by mini-css-extract-plugin
export default {"container":"Accessibility_container__p4KJn","block":"Accessibility_block__U-J+p","open":"Accessibility_open__fS3KE","icon":"Accessibility_icon__kQB-l"};